<template>
    <div></div>
</template>

<script>
    export default {
        name: "Logout",
        async created() {
            const loader = await this.$ionic.loadingController.create({
                message: this.$t('ncrypt.notifications.being_logged_out'),
                duration: 10000,
            });
            await loader.present();

            await this.$store.dispatch('logout');

            await this.$router.push({name: 'login'});

            this.$nextTick(async () => this.$router.go(this.$router.currentRoute));
        },
    }
</script>
